/* eslint-disable no-mixed-operators */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { HttpClient } from '@angular/common/http';
import { Injectable, OnDestroy } from '@angular/core';
import { Subject, takeUntil } from 'rxjs';
import { SpinnerService } from './spinner.service';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ImageUploadService implements OnDestroy {
  private destroy$ = new Subject<void>();
  constructor(
    private http: HttpClient,
    private _spinnerService: SpinnerService
  ) {}

  onFileChange(event: any): Promise<any> {
    return new Promise((resolve: any) => {
      if (event.target.files && event.target.files[0]) {
        const selectedFile = event.target.files[0];
        if (
          (event.target.files &&
            event.target.files[0] &&
            event.target.files[0].type.startsWith('image/')) ||
          event.target.files[0].type.startsWith('video/')
        ) {
          const formData = new FormData();
          formData.append('file', selectedFile);
          this._spinnerService.addToLoader('uploadImage');

          this.http
            .post(`${environment.image_url}`, formData)
            .pipe(takeUntil(this.destroy$))
            .subscribe({
              next: (res: any) => {
                this._spinnerService.removeFromLoader('uploadImage');
                return resolve(res);
              }
            });
        } else {
          resolve(false);
        }
      }
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
